module.exports = __webpack_public_path__ + "img/Valores.4a292198.svg";